import loggerService from '@widgets/shared/services/loggerService'
import ButtonTinyAudioUrl from '@/assets/sounds/button_tiny.mp3'

const notificationSoundId = 'notification' as const
type InnerId = typeof notificationSoundId

export class SoundService<ID extends string = string> {
  protected audioMap = new Map<ID | InnerId, HTMLAudioElement>()

  public warmup(id: ID | InnerId, url: string) {
    const audio = new Audio(url)
    audio.id = id
    audio.preload = 'auto'
    audio.loop = false
    audio.load()
    this.audioMap.set(id, audio)
  }

  public play(id: ID | InnerId, volume?: number) {
    const audio = this.audioMap.get(id)
    if (!audio) {
      loggerService.logError(`Audio not found: ${id}`)
      return
    }
    audio.volume = volume ?? 0.5
    audio.play().catch((error: Error) => {
      const msg = `${(error as Error).message}, id=${id}, url=${audio.src}`
      loggerService.logError(msg)
    })
  }

  public warmupNotificationSound() {
    this.warmup(notificationSoundId, ButtonTinyAudioUrl)
  }

  public playNotificationSound() {
    this.play(notificationSoundId, 0.5)
  }
}

export default new SoundService()
